<template>
   <v-card class="padding elevation-0" flat>
      <v-dialog v-model="modal" v-if="modal" max-width="400">
         <v-card class="pa-3">
            <h2>Alterar Status do Boleto</h2>
            <v-layout row nowrap>
               <v-flex xs9>
                  <v-select
                     :items="optionsStatus"
                     item-text="text"
                     item-value="value"
                     label="Selecione um Status"
                     v-model="selectedStatus"
                  ></v-select>
               </v-flex>
               <v-flex xs2>
                  <v-btn style="margin-top: 20px" icon flat @click="changeStatus">
                     <v-icon>send</v-icon>
                  </v-btn>
               </v-flex>
            </v-layout>


         </v-card>
      </v-dialog>

      <v-card-title >
         <h1 class="fonte">Histórico de Transação</h1>
         <v-spacer></v-spacer>
         <v-autocomplete
            color="blue-grey"
            v-model="selected"
            label="Selecione o Cliente"
            :items="clientes"
            item-text="email"
            item-value="_id"
            no-data-text="Sem Resultados"
         ></v-autocomplete>

         <v-icon style="cursor: pointer; margin-left: 5px" @click="getBoletos">search</v-icon>
      </v-card-title>
      <v-container>
         <h1 class="fonte mb-2 text-uppercase">Boletos</h1>
         <v-data-table
            :headers="headers"
            :items="dataTable"
            class="elevation-1"
            :rows-per-page-items="[20]"
            :loading="loadingBoletos"
            no-data-text="Sem Boletos"
         >
            <template
               v-slot:items="props"
            >
                <td class="text-sm-center">
                    <v-btn v-if="props.item._id" depressed small @click="openModal(props.item._id)">
                        {{
                            (props.item.status === 'paid' && 'pago') ||
                            (props.item.status === 'expired' && 'expirado') ||
                            (props.item.status === 'canceled' && 'cancelado')
                        }}
                    </v-btn>
                    <span v-else>
                        {{ props.item.status }}
                    </span>
                </td>
                <td class="text-sm-center">{{ new Date(props.item.date).toLocaleString() }}</td>
                <td class="text-sm-center">{{ props.item.valor }}</td>
                <td class="text-xs-center">
                    <v-btn v-if="props.item.url" round color="fundo" dark :href="props.item.url" target="_blank">
                        <v-icon>attach_file</v-icon>
                    </v-btn>
                    <span v-else>
                        Inserido por: {{ props.item.nome }}
                    </span>
                </td>
            </template>
         </v-data-table>
      </v-container>



   </v-card>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            modal          : false,
            loadingBoletos : false,
            selected       : '',
            selectedStatus : '',
            clientes       : [],
            boletos        : [],
            creditsManual  : [],

            statusChange   : {
            _id  : '',
            status   : ''
            },

            optionsStatus  : [
                { text: 'Cancelado', value: 'canceled' },
                { text: 'Expirado',  value: 'expired' },
                { text: 'Pago',      value: 'paid' }
            ],

            headers        : [
                { text: 'Status', align: 'center', sortable: false },
                { text: 'Data', align: 'center', sortable: false },
                { text: 'Valor', align: 'center', sortable: false },
                { text: 'Boleto/Inserção Manual', align: 'center', sortable: false }
            ]
        }
    },

    async mounted() {
        this.clientes = await this.loadUsuariosAstandes()
    },

    methods: {
        ...mapActions(['loadUsuariosAstandes', 'loadBoletosByUserId', 'updateStatusBoleto']),

        async getBoletos() {
            this.loadingBoletos             = true
            const { data, creditsManual }   = await this.loadBoletosByUserId(this.selected)
            this.boletos                    = data
            this.creditsManual              = creditsManual
            this.loadingBoletos             = false
        },

        async openModal(id) {
            this.modal                 = true
            this.statusChange._id  = id
        },

        async changeStatus() {
            this.statusChange.status = this.selectedStatus
            const { status, message } = await this.updateStatusBoleto(this.statusChange)

            this.$eventHub.$emit('snackBar', {color: !status ? 'error' : 'success', message })

            this.modal = false

            this.statusChange._id = ''
            this.statusChange.status = ''
            this.selectedStatus = ''

            await this.getBoletos()

        }
    },

    computed: {
        //...mapGetters(["getPagamentos"]),
        dataTable() {
            let data = []

            data = this.boletos.map( _ => ({
                _id     : _._id,
                status  : _.status,
                valor   : _.total,
                url     : _.url,
                date    : _.createdAt
            }))

            data = [ ...data, ...this.creditsManual.map( _ => ({
                _id     : null,
                status  : 'Inserido manualmente',
                valor   : _.valor,
                url     : null,
                nome    : _.nome,
                date    : _.date
            })) ]

            return data
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/root/HistoricoTransacao.vue